import * as React from 'react';

import { connect, ConnectedProps } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router-dom';

import { authSelectors } from 'auth/duck';
import { RouterProps } from 'typedefs/router';

interface OwnProps {
  component: React.ComponentType<RouterProps>;
}
type ReduxProps = ConnectedProps<typeof connector>;
type Props = RouteProps & OwnProps & ReduxProps;

const PrivateRoute: React.FunctionComponent<Props> = ({
  authenticated,
  authorized,
  component: Component,
  ...rest
}) => (
  <Route {...rest}>
    {(props: RouterProps) => {
      if (!authenticated) {
        return (
          <Redirect
            to={{ pathname: '/login', state: { from: props.location } }}
          />
        );
      } else if (!authorized) {
        return <Redirect to={{ pathname: '/forbidden' }} />;
      }

      return <Component {...props} />;
    }}
  </Route>
);

const mapState = (state: RootState) => ({
  authorized: authSelectors.isAuthorizedSelector(state),
  authenticated: authSelectors.selectIsAuthenticated(state),
});

const connector = connect(mapState);

export default connector(PrivateRoute);
